<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12" v-if="content">
        <exercise-logic-multiple
          exCollection="fourCornersCompetitionExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef"
          :doc="doc"
          :shared="true"
          :projectShared="false"
          :pid="true"
          :eid="$route.params.eid"
          :synced="false"
          :saveState="saveState"
        >
          <template slot-scope="{ saveExercise }">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="1"
                  @click="navigateTo('client')"
                  >Client</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="2"
                  @click="navigateTo('customer')"
                  >Customer</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="3"
                  @click="navigateTo('context')"
                  >Context</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="4"
                  @click="navigateTo('competition')"
                  >Competition</v-stepper-step
                >
                <v-divider></v-divider>
              </v-stepper-header>

              <v-stepper-items>
                <!-- Step 1 -->
                <v-stepper-content step="4">
                  <v-row>
                    <v-col cols="4" class="mb-4">
                      <h2
                        class="headline"
                        v-text="content.exercise_four_competition.step1.title"
                      ></h2>
                    </v-col>

                    <v-col cols="8" class="">
                      <p
                        v-for="(item, index) in content
                          .exercise_four_competition.step1.description"
                        :key="index"
                        v-text="item"
                      />
                    </v-col>
                  </v-row>
                  <!-- loop through questions from language file -->
                  <v-row v-if="doc">
                    <v-col cols="4">
                      <four-corners-col
                        v-model="doc.list1"
                        :key="`list1-${doc.list1.length}`"
                        :title="
                          content.exercise_four_competition.competition_title_1
                            .title
                        "
                        :list-count="listCount"
                        @autosave="doAutoSave"
                      />
                    </v-col>
                    <v-col cols="4">
                      <four-corners-col
                        v-model="doc.list2"
                        :key="`list2-${doc.list2.length}`"
                        :title="
                          content.exercise_four_competition.competition_title_2
                            .title
                        "
                        :list-count="listCount"
                        @autosave="doAutoSave"
                      />
                    </v-col>
                    <v-col cols="4">
                      <four-corners-col
                        v-model="doc.list3"
                        :key="`list3-${doc.list3.length}`"
                        :title="
                          content.exercise_four_competition.competition_title_3
                            .title
                        "
                        :list-count="listCount"
                        @autosave="doAutoSave"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-card>
                        <v-card-text>
                          <unit-items
                            v-model="doc.list4"
                            :key="`list4-${doc.list4.length}`"
                            name="technology"
                            :title="
                              content.exercise_four_competition.technology.title
                            "
                            @autosave="doAutoSave"
                          ></unit-items>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card>
                        <v-card-text>
                          <unit-items
                            v-model="doc.list5"
                            :key="`list5-${doc.list5.length}`"
                            name="other"
                            :title="
                              content.exercise_four_competition.other.title
                            "
                            @autosave="doAutoSave"
                          ></unit-items>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <bottom-navigation
                    :save="true"
                    :next="false"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    :list="`four-corners`"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="saveExercise(false)"
                  >
                  </bottom-navigation>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card light>
        <v-card-title
          class="headline"
          v-text="$t('exercise_four_competition.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-btn
            color="white"
            top
            right
            absolute
            class="black--text"
            @click="dialog = false"
          >
            Close
          </v-btn>

          <v-btn
            class="grey lighten-3"
            :to="`/users/project/${this.$route.params.id}`"
          >
            Back to Project
          </v-btn>
          <v-btn
            class="amber"
            :to="`/users/project/${this.$route.params.id}/four-corners`"
          >
            Back to List
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";

import { FourCornersCol } from "@/views/user/exercises/four-corners";
import { UnitItems } from "@/components/units";

export default {
  name: "UserFourCornersCustomer",
  data() {
    return {
      e1: 4,
      content: null,
      saveState: false,
      autoSave: true,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "add",
      allItems: null,
      listName: "",
      listCount: 0,
      doc: {
        title: "",
        list1: [],
        list2: [],
        list3: [],
        list4: [],
        list5: [],
        list: {},
        listNames: [],
        allItems: [],
        audienceAll: [],
        contentAll: [],
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    FourCornersCol,
    UnitItems,
  },
  watch: {
    // e1(val) {
    //   if (val === 3) {
    //     this.createList();
    //   }
    // },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
    console.log("data", data);
  },

  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedRef(refs) {
      console.log("loaded refs", refs);
    },
    onLoadedEx(items) {
      console.log("loaded exercises", items);
      if (items) {
        this.mergeArrays(items[0].doc);
      }
    },
    onModifyEx(items) {
      // console.log("modify exercises", items);
      this.exercises = [...items];
    },
    onSavedNext() {
      // this.nextStep();
      this.saveState = false;
    },

    clone(obj) {
      Object.assign({}, obj);
    },

    doAutoSave() {
      if (this.autoSave) {
        console.log("doing autosave");
        this.saveState = true;
      }
    },

    navigateTo(slug) {
      this.$router.push(
        `/users/project/${this.$route.params.id}/${slug}/shared`
      );
    },
    mergeArrays(arr) {
      Object.entries(arr).forEach(([outerKey, value]) => {
        if (typeof value !== "object") {
          this.doc[outerKey] = value;
        } else {
          Object.entries(value).forEach(([key, value]) => {
            this.doc[outerKey][key] = value;
          });
        }
      });
      this.listCount++;
    },
  },
};
</script>

<style lang="scss"></style>
